import { render } from "./Parametrizacao.vue?vue&type=template&id=6c75c9cf"
import script from "./Parametrizacao.vue?vue&type=script&lang=js"
export * from "./Parametrizacao.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__